import * as React from 'react';

import ReviewsPageDirector from 'bundles/reviews/components/ReviewsPageDirector';
import EnterpriseOrgScopedPageDataProvider from 'bundles/unified-common/providers/org-scoped/data/EnterpriseOrgScopedPageDataProvider';
import EnterpriseOrgUserExperienceHandler from 'bundles/unified-common/providers/org-scoped/data/EnterpriseOrgUserExperienceHandler';

const EnterpriseOrgScopedReviewsPageDirector = () => (
  <EnterpriseOrgScopedPageDataProvider>
    <EnterpriseOrgUserExperienceHandler>
      <ReviewsPageDirector />
    </EnterpriseOrgUserExperienceHandler>
  </EnterpriseOrgScopedPageDataProvider>
);

export default EnterpriseOrgScopedReviewsPageDirector;
